import PublicLayout from "../../components/marketing/PublicLayout";
import { useMarketingLang } from "../../lib/useMarketingLang";
import { IMG } from "../../i18n/marketingImages";
import { MapPin, Ship, Leaf } from "lucide-react";

const pillarIcons = [MapPin, Ship, Leaf];

export default function MarketingAbout() {
  const { t } = useMarketingLang();
  const a = t.about;
  return (
    <PublicLayout>
      <section className="relative min-h-[380px] flex items-end">
        <img src={IMG.couple} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F1A2B] via-[#0F1A2B]/70 to-[#0F1A2B]/30" />
        <div className="relative max-w-7xl mx-auto px-4 lg:px-8 py-14 lg:py-20 w-full">
          <div className="text-xs uppercase tracking-[0.42em] text-[#ECC974] mb-3">{a.eyebrow}</div>
          <h1 className="text-3xl lg:text-5xl font-bold text-white leading-tight max-w-4xl">
            {a.title}
          </h1>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 lg:px-8 py-14">
        <p className="text-lg text-[#0F1A2B] leading-relaxed">{a.lead}</p>
      </section>

      <section className="bg-[#F8F7F2] py-14">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 grid md:grid-cols-3 gap-6">
          {a.pillars.map((p, i) => {
            const Icon = pillarIcons[i];
            return (
              <div key={i} className="bg-white rounded-2xl p-6 border border-[#A57F39]/15 shadow-sm">
                <div className="h-12 w-12 rounded-full bg-[#A57F39]/10 text-[#A57F39] flex items-center justify-center mb-4">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="text-lg font-bold text-[#0F1A2B] mb-2">{p.title}</h3>
                <p className="text-sm text-[#0F1A2B]/70 leading-relaxed">{p.body}</p>
              </div>
            );
          })}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 lg:px-8 py-16 lg:py-20 grid lg:grid-cols-2 gap-10 items-start">
        <div>
          <div className="text-xs uppercase tracking-[0.32em] text-[#A57F39] mb-3">{a.storyTitle}</div>
          <h2 className="text-3xl lg:text-4xl font-bold text-[#0F1A2B] mb-6">{a.storySub}</h2>
          <div className="space-y-4">
            {a.storyText.map((p, i) => (
              <p key={i} className="text-[#0F1A2B]/80 leading-relaxed">{p}</p>
            ))}
          </div>
          <blockquote className="mt-6 italic text-[#0F1A2B] border-l-4 border-[#A57F39] pl-5 text-lg">
            {a.quote}
          </blockquote>
        </div>
        <img src={IMG.ernst} alt="Ernst Terje Jakobsen" className="w-full rounded-3xl shadow-xl aspect-[4/3] object-cover" />
      </section>

      <section className="bg-[#0F1A2B] text-white py-16">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 grid lg:grid-cols-2 gap-10">
          <img src={IMG.office} alt="" className="w-full aspect-[4/3] object-cover rounded-3xl" />
          <div>
            <div className="text-xs uppercase tracking-[0.32em] text-[#ECC974] mb-3">{a.baseTitle}</div>
            <h2 className="text-3xl font-bold mb-5">{a.baseSub}</h2>
            <ul className="space-y-2 mb-6">
              {a.baseBullets.map((b, i) => (
                <li key={i} className="flex items-start gap-2 text-white/85">
                  <span className="text-[#BD984D] mt-1">•</span> {b}
                </li>
              ))}
            </ul>
            <p className="text-white/75 leading-relaxed">{a.baseBody}</p>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
